// utils/permissions.js

export const getUserPermissions = () => {
  try {
    const raw = localStorage.getItem("auth");
    //console.log(raw);
    let parsed;
    if (raw) {
      let parsedObj = JSON.parse(raw);
      parsed = parsedObj.admin.permissions;
      console.log(parsed);
    } else {
      parsed = [];
    }
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const hasPermission = (requiredPermission, userPerms = getUserPermissions()) => {
  if (!requiredPermission) return true;
  return userPerms.includes(requiredPermission);
};

// utils/permissions.js

export const filterRoutesByPermission = (routes, userPerms = getUserPermissions()) =>
  (routes || [])
    .map((route) => {
      const hasChildren = Array.isArray(route.collapse) && route.collapse.length > 0;

      // Parent group with children
      if (hasChildren) {
        const filteredChildren = filterRoutesByPermission(route.collapse, userPerms);

        // keep parent if ANY child remains
        if (filteredChildren.length > 0) {
          return { ...route, collapse: filteredChildren };
        }

        return null;
      }

      // Leaf route: only enforce if permission exists
      if (route.permission && !hasPermission(route.permission, userPerms)) return null;

      // If it's a group but collapse is empty, treat it like a leaf menu item
      // (don't kill it unless it has permission you don't have)
      return route;
    })
    .filter(Boolean);
